import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForSpecialOfferSixty(context: EditionAwarenessContextType): boolean {
	const { isInCollection, product, entitlementId, transactionAccountId, canDirectBuyUpgrade } =
		context;

	return (
		product === 'jira' &&
		!isInCollection &&
		Boolean(entitlementId) &&
		Boolean(transactionAccountId) &&
		Boolean(canDirectBuyUpgrade) &&
		fg('special_offer_60_days_jira_standard_kill_switch')
	);
}
